import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-GrayOvalShape",
  "use": "svg-icon-GrayOvalShape-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-GrayOvalShape\"><path clip-rule=\"evenodd\" d=\"M12.599 24.637c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.627 5.372 12 12 12z\" fill=\"#434445\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol